<template>
	<div>
		<div class="box-list">
			<div class="top-list">
				<span class="title">{{ $vnode.key}} {{ colecao.nome }}<i class="fas fa-chevron-down" ></i></span>
				<div class="btns-list" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId">
					<button class="rename" @click="renameCollection(colecao)"><i class="fas fa-edit"></i> <span class="text"> editar </span></button>
					<button class="add" @click="createCollection(colecao.id)"><i class="fas fa-folder-plus"></i><span class="text"> adicionar </span></button>
					<button class="remove" @click="removeCollection(colecao.id)"><i class="fas fa-trash-alt"></i><span class="text"> excluir </span></button>
				</div>
			</div>
			<draggable class="draggable" v-model="colecao.objetos" group="colecao.id" @start="drag=$auth.user().id === colecao.autorId" @end="reorderCollection(colecao)" :draggable="'.colecao-'+ colecao.id" :move="checkMoveObjectCollection" :disabled="colecao.status !== 'Rascunho' || $auth.user().id !== colecao.autorId">
				<div class="object-list" :class="'object-list colecao-' + colecao.id" v-for="(obj, index) in colecao.objetos" :key="index + 1">
					<span class="number" > #{{index + 1}} <div class="ball"></div></span>
					<div class="box-object">
						<span>
							<i class="fas fa-arrows-alt"></i>
						</span>
						<span class="name-object">{{obj.titulo}}</span>
						<span class="type">Tipo: {{ obj.tipoNome }}</span>
						<div class="bts">
							<div class="comment" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId" @click="commentObjectCollection(obj)" ><span class="material-icons">add_comment</span><span class="txt">comentar</span></div>
							<div class="view" @click="$router.push('/objeto/' + obj.objetoId)"><i class="fas fa-eye"></i><span class="txt-view"></span><span class="txt">visualizar</span></div>
							<div class="delete" v-if="colecao.status === 'Rascunho' && $auth.user().id === colecao.autorId"  @click="removeObjectCollection(colecao.id, obj.objetoId)"><i class="fas fa-trash-alt"></i><span class="txt">excluir</span></div>
						</div>
					</div>
				</div>
			</draggable>
		</div>
		<SubColecoes v-for="(col, index) in colecao.subColecoes" :key="$vnode.key + '.' + (index + 1)" :colecao="col" :colecoes="colecoes"></SubColecoes>
	</div>
</template>
<script>
import draggable from 'vuedraggable'
import SubColecoes from './SubColecoes'
import EventBus from '@/components/event-bus'
export default {
	name: 'SubColecoes',
	props: ['colecao', 'colecoes'],
	components: { SubColecoes, draggable },
	methods: {
		reorderCollection (colecao) {
			EventBus.$emit('reorderCollection', colecao)
		},
		commentObjectCollection (objetoColecao) {
			EventBus.$emit('commentObjectCollection', objetoColecao)
		},
		removeCollection (id = null) {
			EventBus.$emit('removeCollection', id)
		},
		createCollection (colecaoId = null) {
			EventBus.$emit('createCollection', colecaoId)
		},
		renameCollection (colecao = null) {
			EventBus.$emit('renameCollection', colecao)
		},
		removeObjectCollection (colId, objId) {
			EventBus.$emit('removeObjectCollection', colId, objId)
		},
		checkMoveObjectCollection: function (evt) {
			return (evt.relatedContext.element.colecaoId === evt.draggedContext.element.colecaoId)
		}
	}
}
</script>
<style lang="scss" scoped>

.box-list {
	display: flex;
	flex-direction: column;
	align-items: center;

	&:nth-child(odd){
		border: solid 1px;
		border-color:#59708F;
		border-right: none;
		border-left: none;
	}

	&:last-child {
		border: solid 1px;
		border-color:#59708F;
		border-right: none;
		border-left: none;
		border-top: none;
	}

	.top-list {
		display: flex;
		justify-content: space-between;
		color: #FFFFFF;
		width:100%;
		margin-bottom: 20px;
		margin-top: 20px;

		.title {
			text-transform: uppercase;
			font-weight: 700;
			font-size: 20px;
			color:#FFFFFF;
			margin-top: 9px;
			margin-bottom: 12px;
			margin-left:5%;

			i{
				color: #59708F;
				margin-right: 10px;
				margin-left: 10px;
			}
		}
		.btns-list {
			display: inline-flex;
			justify-content: space-around;
			color:#FFFFFF;
			font-family: Roboto;
			font-stretch: condensed;
			margin-right: 26px;

			.rename, .add, .remove {
				display: flex;
				align-items: center;
				background-color:#59708F;
				padding: 9px 15px 10px;
				border: none;
				color: #FFF;
				font-size: 20px;
				border-radius: 5px;
				margin-right: 10px;
				font-family: Roboto;
				max-width: 50px;
				min-width: 50px;
				cursor: pointer;
				transition: 0.666s max-width ease;

				.text {
					display: inline-block;
					transform: scaleX(0);
					transition: 0.444s transform ease;
					transform-origin: left center;
					margin-left: 10px;
					padding-right: 5px;
				}
			}
			.rename:hover, .voltar:hover{
				background-color:#ffffff;
				color: #59708F;
				max-width: 200px;
				.text {
					transform: scaleX(1)
				}
			}
			.add:hover {
				background-color:#e2e41a;
				color: #59708F;
				max-width: 200px;
				.text {
					transform: scaleX(1)
				}
			}
			.remove:hover {
				background-color:#d9534f;
				color: #ffffff;
				max-width: 200px;
				.text {
					transform: scaleX(1)
				}
			}
		}
	}

	.draggable {
		width:100%;

		.object-list {
			display: flex;
			align-items: center ;
			margin-bottom: 10px;
			cursor: move;

			.number {
				display: flex;
				color: #59708F;
				font-size: 20px;
				font-weight: 700;
				width: 5%;
				align-items: center;

				.ball {
					background-color: #59708F;
					border-radius:5px;
					width: 9px;
					height: 9px;
					margin-left: 5px;
				}
			}
			.box-object {
				display: grid;
				width:100%;
				align-items: center;
				grid-template-columns: 2fr 7fr 7fr 2fr;
				padding: 10px 20px;
				border-radius: 10px;
				background-color: #061529;
				color: #59708F;
				font-family: 'Roboto Condensed', 'Roboto', sans-serif;
				cursor: move;

				i {
					color: #59708F;
				}

				.name-object {
					color: #99BCE5;
				}

				.type {
					color: #FFFFFF;
				}

				.bts {
					display:flex;
					color:#FFFFFF;
					font-family: Roboto;
					font-stretch: condensed;

					.comment, .view, .delete {
						display: flex;
						align-items: center;
						padding: 8px;
						border: none;
						color: #FFF;
						font-size: 20px;
						border-radius: 5px;
						margin-right: 10px;
						font-family: Roboto;
						max-width: 50px;
						min-width: 50px;
						cursor: pointer;
						transition: 0.666s max-width ease;

						i {
							color: #FFF;
						}

						.txt {
							display: inline-block;
							transform: scaleX(0);
							transition: 0.444s transform ease;
							transform-origin: left center;
							margin-left: 10px;
							padding-right: 5px;
							color: #FFF;
							font-size: 16px;
						}
					}
					.comment:hover {
						max-width: 200px;
						color: #FFF;
						.txt {
							color: #FFF;
							transform: scaleX(1);
						}
					}
					.view:hover {
						max-width: 200px;
						i {
							color: #e2e41a;
						}
						.txt {
							color: #e2e41a;
							transform: scaleX(1);
						}
					}
					.delete:hover {
						max-width: 200px;
						i {
							color: #d9534f;
						}
						.txt {
							color: #d9534f;
							transform: scaleX(1);
						}
					}
				}
			}
		}
	}
}
</style>
